import React, { useEffect, useState } from 'react';
import './HealthConcernRate.scss';
import SingleRate from "../SingleRate/SingleRate";

const HealthConcernRate = ({
                               themeColor,
                               i18n,
                               rate,
                               setRate,
                               leftOption,
                               rightOption,
                               hasSpecificRate,
                               newScale = false,
                               scaleVariant = "regular",
                           }) => {
    const [rateCount, setRateCount] = useState(10);
    const [startIndex, setStartIndex] = useState(1);

    useEffect(() => {
        if (hasSpecificRate) {
            setRateCount(5);
            setStartIndex(1);
        } else if (newScale) {
            setRateCount(11);
            setStartIndex(0); // important for supporting 0
        } else {
            setRateCount(10);
            setStartIndex(1);
        }
    }, [newScale, hasSpecificRate]);

    const clickedConcernRate = (rateValue) => {
        if (rate === rateValue) {
            setRate(null); // deselect if clicked again
        } else {
            setRate(rateValue); // allow 0
        }
    };

    const redToGreenScale = [
        "rgb(166, 1, 35)",
        "rgb(212, 2, 40)",
        "rgb(237, 11, 10)",
        "rgb(244, 56, 4)",
        "rgb(249, 117, 2)",
        "rgb(248, 179, 0)",
        "rgb(250, 220, 1)",
        "rgb(205, 223, 15)",
        "rgb(140, 213, 33)",
        "rgb(69, 188, 55)",
        "rgb(23, 170, 64)",
    ];

    const greenToRedScale = [...redToGreenScale].reverse();
    const isGradientScale = scaleVariant === "green_to_red" || scaleVariant === "red_to_green";
    const endRateValue = startIndex + rateCount - 1;

    const getRateColor = (rateValue) => {
        if (!isGradientScale) {
            return themeColor;
        }

        const colorIndex = Math.max(0, Math.min(10, Number(rateValue)));
        const activePalette = scaleVariant === "green_to_red" ? greenToRedScale : redToGreenScale;
        return activePalette[colorIndex];
    };

    const leftColor = isGradientScale ? getRateColor(startIndex) : undefined;
    const rightColor = isGradientScale ? getRateColor(endRateValue) : undefined;
    const leftIcon = isGradientScale ? (scaleVariant === "green_to_red" ? "/assets/ic_like.svg" : "/assets/ic_dislike.svg") : null;
    const rightIcon = isGradientScale ? (scaleVariant === "green_to_red" ? "/assets/ic_dislike.svg" : "/assets/ic_like.svg") : null;

    return (
        <div className="HealthConcernRate">
            <div className="healthRates">
                {[...Array(rateCount)].map((_, index) => {
                    const rateValue = startIndex + index;
                    const isSelected = rate === rateValue;

                    return (
                        <div
                            className="rateContainer"
                            key={index}
                            onClick={() => clickedConcernRate(rateValue)}
                        >
                            {
                                index === 0 && <>
                                    <div className="mobileHealthRateNames">
                                        {isGradientScale ? (
                                            <>
                                                <div className="severenessText scaleVariantLabel" style={{color: leftColor}}>
                                                    <img src={leftIcon} alt={leftOption || "left option"} className="scaleVariantIcon"/>
                                                    <span>{leftOption ? `${startIndex} → ${leftOption}` : null}</span>
                                                </div>
                                                <div className="severenessText scaleVariantLabel" style={{color: rightColor}}>
                                                    <img src={rightIcon} alt={rightOption || "right option"} className="scaleVariantIcon"/>
                                                    <span>{rightOption ? `${endRateValue} → ${rightOption}` : null}</span>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="severenessText">
                                                    {leftOption ? `${startIndex} → ${leftOption}` : null}
                                                </div>
                                                <div className="severenessText">
                                                    {rightOption ? `${endRateValue} → ${rightOption}` : null}
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </>
                            }

                            <SingleRate
                                rate={rateValue}
                                selectedRate={rate}
                                themeColor={themeColor}
                                hasSpecificRate={hasSpecificRate}
                                selectedColor={isGradientScale ? getRateColor(rateValue) : null}
                                unselectedBorderColor={isGradientScale ? "#B8B8B8" : null}
                                status={isSelected && !hasSpecificRate ? 'selected' : null}
                            />
                            {hasSpecificRate ? (
                                <div className="specificRateText">{rateValue}</div>
                            ) : null}
                        </div>
                    );
                })}
            </div>

            <div className="healthRateNames">
                {isGradientScale ? (
                    <>
                        <div className="severenessText scaleVariantLabel" style={{color: leftColor}}>
                            <img src={leftIcon} alt={leftOption || "left option"} className="scaleVariantIcon"/>
                            <span>{leftOption}</span>
                        </div>
                        <div className="severenessText scaleVariantLabel scaleVariantLabelRight" style={{color: rightColor}}>
                            <span>{rightOption}</span>
                            <img src={rightIcon} alt={rightOption || "right option"} className="scaleVariantIcon"/>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="severenessText">{leftOption}</div>
                        <div className="severenessText">{rightOption}</div>
                    </>
                )}
            </div>
        </div>
    );
};

export default HealthConcernRate;
